module.exports = __webpack_public_path__ + "assets/img/thumb-BodyLux.5052a891.webp";